import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path, Rect } from 'react-native-svg';

const PlusIconV2 = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    backgroundColor?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.width ?? 42}
          height={props.height ?? 40}
          viewBox="0 0 42 40"
          fill="none"
          {...props}
        >
          <Rect
            x="0.617188"
            y="0.466797"
            width="41"
            height="39"
            rx="8"
            fill={props.backgroundColor ?? 'white'}
            fillOpacity="0.85"
          />
          <Path
            d="M24.895 31.5199H17.3856V22.8552H8.77344V16.8162H17.3856V8.41406H24.895V16.8162H33.4547V22.8552H24.895V31.5199Z"
            fill={props.color ?? '#E2753A'}
          />
        </Svg>
      </View>
    );
  },
);

export { PlusIconV2 };
